import type React from 'react'
import { useState } from 'react'
import styled from 'styled-components'
import { theme } from '../../theme/theme'

const TooltipContainer = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
`

const TooltipContent = styled.div<{ visible: boolean }>`
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(-8px);
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  background-color: ${({ theme }) => theme.colors.text};
  color: ${({ theme }) => theme.colors.background};
  border-radius: ${theme.borderRadius.sm};
  font-size: ${theme.typography.xs};
  white-space: nowrap;
  z-index: 1000;
  pointer-events: none;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  transition: opacity 0.2s ease, visibility 0.2s ease;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-top-color: ${({ theme }) => theme.colors.text};
  }
`

interface TooltipProps {
  content: string
  children: React.ReactNode
}

export const Tooltip: React.FC<TooltipProps> = ({ content, children }) => {
  const [visible, setVisible] = useState(false)

  return (
    <TooltipContainer onMouseEnter={() => setVisible(true)} onMouseLeave={() => setVisible(false)}>
      {children}
      <TooltipContent visible={visible}>{content}</TooltipContent>
    </TooltipContainer>
  )
}
